import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { ArrowRightOutlined, CheckCircleOutlined } from '@ant-design/icons';
import Draggable from 'react-draggable';
import styles from './captcha.module.less';

function Captcha(props) {
  const track = useRef();
  const [value, setValue] = useState(props.value || 'fail');
  const [stopPositionX, setStopPositionX] = useState(0);
  useEffect(() => {
    setValue(props.value);
    if (props.value !== 'success') {
      setStopPositionX(0);
    }
  }, [props.value]);

  function isSuccess(x) {
    return x >= track.current.clientWidth - 40;
  }

  function onDrag(e, { x }) {
    setStopPositionX(x);
  }

  function onStop(e, { x }) {
    if (isSuccess(x)) {
      setStopPositionX(x);
      props.onChange('success');
      props.onSuccess();
    } else {
      setStopPositionX(0);
      props.onChange('fail');
    }
  }

  return (
    <div className={styles.captchaContainer}>
      <div className={styles.captchaTrack} ref={track}>
        <Draggable
          axis="x"
          position={{ x: stopPositionX, y: 0 }}
          bounds="parent"
          onStop={onStop}
          onDrag={onDrag}
          disabled={value === 'success'}
        >
          <div className={styles.captchaSlider}>
            <ArrowRightOutlined />
          </div>
        </Draggable>
        <div className={styles.finsSuccess} style={{ width: stopPositionX + 20 }}>
          {value === 'success' && (
            <span>
              <CheckCircleOutlined />
              &nbsp;验证通过
            </span>
          )}
        </div>
        <div className={styles.finsTips}>向右拖动滑块验证</div>
      </div>
    </div>
  );
}

Captcha.propTypes = {
  value: PropTypes.oneOf(['success', 'fail']),
  onChange: PropTypes.func,
  onSuccess: PropTypes.func,
};

Captcha.defaultProps = {
  onChange: () => null,
  onSuccess: () => null,
};
export default Captcha;
